import { FC } from 'react';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import { Breadcrumb } from '#baseBreadcrumbs/containers';

const Breadcrumbs: FC = () => {
  const { seo } = useAdvertDetailContext();

  return seo.breadcrumbs.map((breadcrumb) => (
    <Breadcrumb
      key={breadcrumb.id}
      id={breadcrumb.id}
      title={breadcrumb.title}
      to={breadcrumb.to}
      state={breadcrumb.state}
    />
  ));
};

export { Breadcrumbs };
